import { render, staticRenderFns } from "./Cellphones.vue?vue&type=template&id=33266e6e&scoped=true"
import script from "./Cellphones.vue?vue&type=script&lang=js"
export * from "./Cellphones.vue?vue&type=script&lang=js"
import style0 from "./Cellphones.vue?vue&type=style&index=0&id=33266e6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33266e6e",
  null
  
)

export default component.exports